// Sketches Data - Organized for Supabase Migration
// Table: sketches

import { ADVANCED_3D_GEOMETRY_DATA } from './advanced3DGeometryData.js';

export const SKETCHES_DATA = [
  // ORIGINAL 3 SKETCHES
  {
    id: "triangle-basic-001",
    category_id: "basic-2d-shapes",
    name: "Triangle",
    description: "Equilateral triangle with vertices at specific coordinates",
    coordinates: "A(200,100), B(100,200), C(300,200)",
    type: "2D",
    difficulty_level: "beginner",
    tags: ["triangle", "equilateral", "2d", "basic"],
    default_params: {
      pointA_x: 200, pointA_y: 100,
      pointB_x: 100, pointB_y: 200,
      pointC_x: 300, pointC_y: 200,
      fill: "lightblue",
      stroke: "blue",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "pointA_x", label: "Point A X", type: "number", min: 0, max: 400 },
      { name: "pointA_y", label: "Point A Y", type: "number", min: 0, max: 300 },
      { name: "pointB_x", label: "Point B X", type: "number", min: 0, max: 400 },
      { name: "pointB_y", label: "Point B Y", type: "number", min: 0, max: 300 },
      { name: "pointC_x", label: "Point C X", type: "number", min: 0, max: 400 },
      { name: "pointC_y", label: "Point C Y", type: "number", min: 0, max: 300 },
      { name: "fill", label: "Fill Color", type: "color" },
      { name: "stroke", label: "Stroke Color", type: "color" },
      { name: "strokeWidth", label: "Stroke Width", type: "number", min: 1, max: 10 }
    ],
    drag_points: ['pointA', 'pointB', 'pointC'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "circle-basic-001",
    category_id: "basic-2d-shapes",
    name: "Circle",
    description: "Circle with center and radius",
    coordinates: "Center(200,150), Radius=80",
    type: "2D",
    difficulty_level: "beginner",
    tags: ["circle", "radius", "2d", "basic"],
    default_params: {
      centerX: 200,
      centerY: 150,
      radius: 80,
      fill: "lightgreen",
      stroke: "green",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 50, max: 350 },
      { name: "centerY", label: "Center Y", type: "number", min: 50, max: 250 },
      { name: "radius", label: "Radius", type: "number", min: 10, max: 150 },
      { name: "fill", label: "Fill Color", type: "color" },
      { name: "stroke", label: "Stroke Color", type: "color" },
      { name: "strokeWidth", label: "Stroke Width", type: "number", min: 1, max: 10 }
    ],
    drag_points: ['center'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "square-pyramid-3d-001",
    category_id: "3d-shapes",
    name: "Square Pyramid",
    description: "Square pyramid with apex and base vertices",
    coordinates: "Base: 4 corners, Apex: top center with height h",
    type: "3D",
    difficulty_level: "intermediate",
    tags: ["pyramid", "3d", "square", "apex"],
    default_params: {
      baseSize: 120,
      height: 100,
      offsetX: 0,
      offsetY: 0,
      offsetZ: 0,
      baseFill: "lightgray",
      sideFill: "lightblue",
      stroke: "black",
      strokeWidth: 2,
      showHeight: true
    },
    parameter_config: [
      { name: "baseSize", label: "Base Size", type: "number", min: 60, max: 180 },
      { name: "height", label: "Height (h)", type: "number", min: 50, max: 150 },
      { name: "offsetX", label: "Offset X", type: "number", min: -30, max: 30 },
      { name: "offsetY", label: "Offset Y", type: "number", min: -30, max: 30 },
      { name: "offsetZ", label: "Offset Z", type: "number", min: -30, max: 30 },
      { name: "baseFill", label: "Base Color", type: "color" },
      { name: "sideFill", label: "Side Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Edge Width", type: "number", min: 1, max: 5 },
      { name: "showHeight", label: "Show Height Line", type: "checkbox" }
    ],
    drag_points: ['apex', 'baseCenter'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  // PREVIOUS 6 SKETCHES
  {
    id: "intersecting-planes-3d-001",
    category_id: "3d-geometry",
    name: "Intersecting Planes",
    description: "Two intersecting planes π₁ and π₂ with angle θ and intersection line",
    coordinates: "Planes π₁, π₂ intersecting at angle θ with points P, Q, R, A, B",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["planes", "intersection", "3d", "angle"],
    default_params: {
      angle: 45,
      planeWidth: 150,
      planeHeight: 100,
      showAngle: true,
      plane1Fill: "rgba(100,150,255,0.3)",
      plane2Fill: "rgba(255,150,100,0.3)",
      intersectionColor: "red",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "angle", label: "Angle θ (degrees)", type: "number", min: 10, max: 80 },
      { name: "planeWidth", label: "Plane Width", type: "number", min: 100, max: 200 },
      { name: "planeHeight", label: "Plane Height", type: "number", min: 60, max: 150 },
      { name: "showAngle", label: "Show Angle θ", type: "checkbox" },
      { name: "plane1Fill", label: "Plane π₁ Color", type: "color" },
      { name: "plane2Fill", label: "Plane π₂ Color", type: "color" },
      { name: "intersectionColor", label: "Intersection Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 5 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "parabola-conic-001",
    category_id: "conic-sections",
    name: "Parabola",
    description: "Parabola y = ax² + bx + c with vertex and focus",
    coordinates: "Vertex at minimum point, focus above vertex",
    type: "2D",
    difficulty_level: "intermediate",
    tags: ["parabola", "conic", "vertex", "focus"],
    default_params: {
      a: 0.02,
      b: 0,
      c: 0,
      vertexX: 200,
      vertexY: 200,
      showFocus: true,
      showVertex: true,
      curveColor: "blue",
      strokeWidth: 3
    },
    parameter_config: [
      { name: "a", label: "Coefficient a", type: "number", min: 0.005, max: 0.05, step: 0.005 },
      { name: "b", label: "Coefficient b", type: "number", min: -0.5, max: 0.5, step: 0.1 },
      { name: "c", label: "Coefficient c", type: "number", min: -50, max: 50 },
      { name: "vertexX", label: "Vertex X", type: "number", min: 100, max: 300 },
      { name: "vertexY", label: "Vertex Y", type: "number", min: 100, max: 250 },
      { name: "showFocus", label: "Show Focus", type: "checkbox" },
      { name: "showVertex", label: "Show Vertex", type: "checkbox" },
      { name: "curveColor", label: "Curve Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 5 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "triangle-angles-001",
    category_id: "angle-geometry",
    name: "Triangle with Angles",
    description: "Triangle PQR with interior angles and side markings",
    coordinates: "Triangle with angles at P, Q, R and sides marked with numbers",
    type: "2D",
    difficulty_level: "intermediate",
    tags: ["triangle", "angles", "interior", "measurements"],
    default_params: {
      pointP_x: 200, pointP_y: 80,
      pointQ_x: 120, pointQ_y: 200,
      pointR_x: 280, pointR_y: 200,
      pointH_x: 200, pointH_y: 140,
      pointK_x: 200, pointK_y: 200,
      showAngles: true,
      showSideNumbers: true,
      triangleColor: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "pointP_x", label: "Point P X", type: "number", min: 150, max: 250 },
      { name: "pointP_y", label: "Point P Y", type: "number", min: 50, max: 120 },
      { name: "pointQ_x", label: "Point Q X", type: "number", min: 80, max: 160 },
      { name: "pointQ_y", label: "Point Q Y", type: "number", min: 180, max: 220 },
      { name: "pointR_x", label: "Point R X", type: "number", min: 240, max: 320 },
      { name: "pointR_y", label: "Point R Y", type: "number", min: 180, max: 220 },
      { name: "showAngles", label: "Show Angle Marks", type: "checkbox" },
      { name: "showSideNumbers", label: "Show Side Numbers", type: "checkbox" },
      { name: "triangleColor", label: "Triangle Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "cyclic-quadrilateral-001",
    category_id: "circle-geometry",
    name: "Cyclic Quadrilateral",
    description: "Circle with inscribed quadrilateral PQRS and angle measurements",
    coordinates: "Circle with points P, Q, R, S on circumference, angles 40° and 56°",
    type: "2D",
    difficulty_level: "advanced",
    tags: ["circle", "quadrilateral", "cyclic", "inscribed"],
    default_params: {
      centerX: 200,
      centerY: 150,
      radius: 80,
      angle1: 40,
      angle2: 56,
      pointP_angle: 45,
      pointQ_angle: 135,
      pointR_angle: 225,
      pointS_angle: 315,
      showAngles: true,
      circleColor: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 120, max: 280 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "radius", label: "Radius", type: "number", min: 60, max: 120 },
      { name: "angle1", label: "Angle 1 (degrees)", type: "number", min: 20, max: 60 },
      { name: "angle2", label: "Angle 2 (degrees)", type: "number", min: 40, max: 80 },
      { name: "pointP_angle", label: "Point P Angle", type: "number", min: 0, max: 90 },
      { name: "pointQ_angle", label: "Point Q Angle", type: "number", min: 90, max: 180 },
      { name: "pointR_angle", label: "Point R Angle", type: "number", min: 180, max: 270 },
      { name: "pointS_angle", label: "Point S Angle", type: "number", min: 270, max: 360 },
      { name: "showAngles", label: "Show Angle Labels", type: "checkbox" },
      { name: "circleColor", label: "Circle Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "pyramid-multiple-views-001",
    category_id: "3d-shapes",
    name: "Pyramid Multiple Views",
    description: "Square pyramid shown from different perspectives with height lines",
    coordinates: "Multiple isometric views of the same pyramid structure",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["pyramid", "multiple-views", "isometric", "3d"],
    default_params: {
      pyramidSize: 60,
      height: 80,
      viewCount: 5,
      showHeightLines: true,
      pyramidFill: "lightgray",
      edgeColor: "black",
      heightColor: "red",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "pyramidSize", label: "Pyramid Size", type: "number", min: 40, max: 80 },
      { name: "height", label: "Height", type: "number", min: 60, max: 120 },
      { name: "viewCount", label: "Number of Views", type: "number", min: 3, max: 6 },
      { name: "showHeightLines", label: "Show Height Lines", type: "checkbox" },
      { name: "pyramidFill", label: "Pyramid Color", type: "color" },
      { name: "edgeColor", label: "Edge Color", type: "color" },
      { name: "heightColor", label: "Height Line Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "midpoint-theorem-001",
    category_id: "theorem-geometry",
    name: "Midpoint Theorem",
    description: "Triangle ABC with midpoints H and K showing parallel line properties",
    coordinates: "Triangle ABC with H midpoint of AB, K midpoint of AC, HK parallel to BC",
    type: "2D",
    difficulty_level: "advanced",
    tags: ["triangle", "midpoint", "theorem", "parallel"],
    default_params: {
      pointA_x: 200, pointA_y: 60,
      pointB_x: 120, pointB_y: 220,
      pointC_x: 320, pointC_y: 220,
      showMidpoints: true,
      showParallelMarks: true,
      showEqualMarks: true,
      triangleColor: "black",
      midlineColor: "red",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "pointA_x", label: "Point A X", type: "number", min: 150, max: 250 },
      { name: "pointA_y", label: "Point A Y", type: "number", min: 40, max: 100 },
      { name: "pointB_x", label: "Point B X", type: "number", min: 80, max: 160 },
      { name: "pointB_y", label: "Point B Y", type: "number", min: 200, max: 250 },
      { name: "pointC_x", label: "Point C X", type: "number", min: 280, max: 360 },
      { name: "pointC_y", label: "Point C Y", type: "number", min: 200, max: 250 },
      { name: "showMidpoints", label: "Show Midpoint Lines", type: "checkbox" },
      { name: "showParallelMarks", label: "Show Parallel Marks", type: "checkbox" },
      { name: "showEqualMarks", label: "Show Equal Marks", type: "checkbox" },
      { name: "triangleColor", label: "Triangle Color", type: "color" },
      { name: "midlineColor", label: "Midline Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  // NEW 6 SKETCHES
  {
    id: "function-roots-001",
    category_id: "function-analysis",
    name: "Function Roots & Horizontal Line",
    description: "Function y = f(x) with horizontal line y = k showing roots (根) intersection points",
    coordinates: "Function curve with horizontal line y = k and vertical dashed lines at roots",
    type: "2D",
    difficulty_level: "advanced",
    tags: ["function", "roots", "horizontal-line", "intersection"],
    default_params: {
      amplitude: 40,
      frequency: 0.02,
      verticalShift: 150,
      horizontalShift: 0,
      horizontalLineY: 120,
      showRoots: true,
      showHorizontalLine: true,
      curveColor: "black",
      horizontalLineColor: "black",
      rootColor: "red",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "amplitude", label: "Wave Amplitude", type: "number", min: 20, max: 60 },
      { name: "frequency", label: "Wave Frequency", type: "number", min: 0.01, max: 0.04, step: 0.002 },
      { name: "verticalShift", label: "Vertical Shift", type: "number", min: 100, max: 200 },
      { name: "horizontalShift", label: "Horizontal Shift", type: "number", min: -50, max: 50 },
      { name: "horizontalLineY", label: "Horizontal Line Y", type: "number", min: 80, max: 180 },
      { name: "showRoots", label: "Show Root Lines", type: "checkbox" },
      { name: "showHorizontalLine", label: "Show y = k Line", type: "checkbox" },
      { name: "curveColor", label: "Curve Color", type: "color" },
      { name: "horizontalLineColor", label: "Line Color", type: "color" },
      { name: "rootColor", label: "Root Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "triangle-interior-angles-001",
    category_id: "angle-geometry",
    name: "Triangle with Interior Angles",
    description: "Triangle ABCD with angles 30°, 45° and interior segments",
    coordinates: "Triangle with vertices A, B, C, D and marked angles 30° and 45°",
    type: "2D",
    difficulty_level: "intermediate",
    tags: ["triangle", "interior-angles", "segments", "measurements"],
    default_params: {
      pointA_x: 320, pointA_y: 80,
      pointB_x: 120, pointB_y: 200,
      pointC_x: 220, pointC_y: 200,
      pointD_x: 280, pointD_y: 200,
      angle30: 30,
      angle45: 45,
      showAngles: true,
      showSegments: true,
      triangleColor: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "pointA_x", label: "Point A X", type: "number", min: 280, max: 360 },
      { name: "pointA_y", label: "Point A Y", type: "number", min: 60, max: 120 },
      { name: "pointB_x", label: "Point B X", type: "number", min: 80, max: 160 },
      { name: "pointB_y", label: "Point B Y", type: "number", min: 180, max: 220 },
      { name: "pointC_x", label: "Point C X", type: "number", min: 180, max: 260 },
      { name: "pointC_y", label: "Point C Y", type: "number", min: 180, max: 220 },
      { name: "pointD_x", label: "Point D X", type: "number", min: 240, max: 320 },
      { name: "pointD_y", label: "Point D Y", type: "number", min: 180, max: 220 },
      { name: "angle30", label: "Angle 1 (degrees)", type: "number", min: 20, max: 40 },
      { name: "angle45", label: "Angle 2 (degrees)", type: "number", min: 35, max: 55 },
      { name: "showAngles", label: "Show Angle Labels", type: "checkbox" },
      { name: "showSegments", label: "Show Internal Segments", type: "checkbox" },
      { name: "triangleColor", label: "Triangle Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "bearing-direction-001",
    category_id: "navigation-geometry",
    name: "Bearing & Direction Triangle",
    description: "Triangle with compass directions (N, S, E, W) and bearing angles 8°, 68°, 52°",
    coordinates: "Triangle BLA with compass bearings and directional angles",
    type: "2D",
    difficulty_level: "intermediate",
    tags: ["bearing", "compass", "navigation", "direction"],
    default_params: {
      pointB_x: 120, pointB_y: 120,
      pointL_x: 200, pointL_y: 200,
      pointA_x: 280, pointA_y: 120,
      bearing1: 8,
      bearing2: 68,
      bearing3: 52,
      showCompass: true,
      showBearings: true,
      triangleColor: "black",
      compassColor: "blue",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "pointB_x", label: "Point B X", type: "number", min: 80, max: 160 },
      { name: "pointB_y", label: "Point B Y", type: "number", min: 80, max: 160 },
      { name: "pointL_x", label: "Point L X", type: "number", min: 160, max: 240 },
      { name: "pointL_y", label: "Point L Y", type: "number", min: 160, max: 240 },
      { name: "pointA_x", label: "Point A X", type: "number", min: 240, max: 320 },
      { name: "pointA_y", label: "Point A Y", type: "number", min: 80, max: 160 },
      { name: "bearing1", label: "Bearing 1 (degrees)", type: "number", min: 5, max: 15 },
      { name: "bearing2", label: "Bearing 2 (degrees)", type: "number", min: 60, max: 80 },
      { name: "bearing3", label: "Bearing 3 (degrees)", type: "number", min: 45, max: 65 },
      { name: "showCompass", label: "Show Compass Directions", type: "checkbox" },
      { name: "showBearings", label: "Show Bearing Angles", type: "checkbox" },
      { name: "triangleColor", label: "Triangle Color", type: "color" },
      { name: "compassColor", label: "Compass Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "double-triangle-construction-001",
    category_id: "geometry-constructions",
    name: "Double Triangle Construction",
    description: "Two triangles ADCX and ABCX sharing vertex C with point B",
    coordinates: "Connected triangular construction with shared vertices",
    type: "2D",
    difficulty_level: "advanced",
    tags: ["construction", "shared-vertices", "complex", "geometric"],
    default_params: {
      pointA_x: 80, pointA_y: 200,
      pointB_x: 160, pointB_y: 200,
      pointC_x: 280, pointC_y: 200,
      pointD_x: 160, pointD_y: 100,
      pointX_x: 360, pointX_y: 200,
      showConstruction: true,
      triangleColor: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "pointA_x", label: "Point A X", type: "number", min: 40, max: 120 },
      { name: "pointA_y", label: "Point A Y", type: "number", min: 180, max: 220 },
      { name: "pointB_x", label: "Point B X", type: "number", min: 120, max: 200 },
      { name: "pointB_y", label: "Point B Y", type: "number", min: 180, max: 220 },
      { name: "pointC_x", label: "Point C X", type: "number", min: 240, max: 320 },
      { name: "pointC_y", label: "Point C Y", type: "number", min: 180, max: 220 },
      { name: "pointD_x", label: "Point D X", type: "number", min: 120, max: 200 },
      { name: "pointD_y", label: "Point D Y", type: "number", min: 80, max: 140 },
      { name: "pointX_x", label: "Point X X", type: "number", min: 320, max: 380 },
      { name: "pointX_y", label: "Point X Y", type: "number", min: 180, max: 220 },
      { name: "showConstruction", label: "Show Construction Lines", type: "checkbox" },
      { name: "triangleColor", label: "Triangle Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "circle-intersecting-chords-001",
    category_id: "circle-geometry",
    name: "Circle with Intersecting Chords",
    description: "Circle with points ABCDE and intersecting chords showing segments 8, 4, 3, x",
    coordinates: "Circle with inscribed polygon and chord intersection properties",
    type: "2D",
    difficulty_level: "advanced",
    tags: ["circle", "chords", "intersection", "segments"],
    default_params: {
      centerX: 200,
      centerY: 150,
      radius: 90,
      pointA_angle: 30,
      pointB_angle: 120,
      pointC_angle: 210,
      pointD_angle: 300,
      pointE_angle: 0,
      segment1: 8,
      segment2: 4,
      segment3: 3,
      segmentX: 6,
      showSegments: true,
      showIntersection: true,
      circleColor: "black",
      chordColor: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 150, max: 250 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "radius", label: "Radius", type: "number", min: 70, max: 110 },
      { name: "pointA_angle", label: "Point A Angle", type: "number", min: 0, max: 90 },
      { name: "pointB_angle", label: "Point B Angle", type: "number", min: 90, max: 180 },
      { name: "pointC_angle", label: "Point C Angle", type: "number", min: 180, max: 270 },
      { name: "pointD_angle", label: "Point D Angle", type: "number", min: 270, max: 360 },
      { name: "pointE_angle", label: "Point E Angle", type: "number", min: 315, max: 45 },
      { name: "segment1", label: "Segment 1 Length", type: "number", min: 5, max: 12 },
      { name: "segment2", label: "Segment 2 Length", type: "number", min: 2, max: 8 },
      { name: "segment3", label: "Segment 3 Length", type: "number", min: 2, max: 6 },
      { name: "segmentX", label: "Segment X Length", type: "number", min: 4, max: 10 },
      { name: "showSegments", label: "Show Segment Labels", type: "checkbox" },
      { name: "showIntersection", label: "Show Intersection Point", type: "checkbox" },
      { name: "circleColor", label: "Circle Color", type: "color" },
      { name: "chordColor", label: "Chord Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "pentagon-in-circle-001",
    category_id: "circle-geometry",
    name: "Pentagon in Circle",
    description: "Regular pentagon ABCDE inscribed in circle with center O and connecting lines",
    coordinates: "Circle with inscribed regular pentagon and radial lines to center",
    type: "2D",
    difficulty_level: "intermediate",
    tags: ["pentagon", "regular", "inscribed", "circle"],
    default_params: {
      centerX: 200,
      centerY: 150,
      radius: 80,
      pentagonRotation: 0,
      showRadialLines: true,
      showCenter: true,
      circleColor: "black",
      pentagonColor: "black",
      radialColor: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 150, max: 250 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "radius", label: "Radius", type: "number", min: 60, max: 120 },
      { name: "pentagonRotation", label: "Pentagon Rotation", type: "number", min: 0, max: 360 },
      { name: "showRadialLines", label: "Show Radial Lines", type: "checkbox" },
      { name: "showCenter", label: "Show Center Point", type: "checkbox" },
      { name: "circleColor", label: "Circle Color", type: "color" },
      { name: "pentagonColor", label: "Pentagon Color", type: "color" },
      { name: "radialColor", label: "Radial Line Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  // NEW ADVANCED GEOMETRIC SKETCHES
  {
    id: "circular-cone-3d-001",
    category_id: "3d-shapes",
    name: "Circular Cone",
    description: "3D circular cone with height (h), radius (r), and slant height (l)",
    coordinates: "Base center at origin, apex at height h, radius r from center",
    type: "3D",
    difficulty_level: "intermediate",
    tags: ["cone", "3d", "circular", "height", "radius", "slant"],
    default_params: {
      centerX: 200,
      centerY: 150,
      radius: 80,
      height: 120,
      showHeight: true,
      showRadius: true,
      showSlant: true,
      baseFill: "rgba(100,100,100,0.3)",
      sideFill: "rgba(150,150,150,0.4)",
      stroke: "black",
      strokeWidth: 2,
      heightColor: "red",
      radiusColor: "blue",
      slantColor: "green"
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 100, max: 300 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "radius", label: "Radius (r)", type: "number", min: 40, max: 120 },
      { name: "height", label: "Height (h)", type: "number", min: 60, max: 180 },
      { name: "showHeight", label: "Show Height Line", type: "checkbox" },
      { name: "showRadius", label: "Show Radius Line", type: "checkbox" },
      { name: "showSlant", label: "Show Slant Height", type: "checkbox" },
      { name: "baseFill", label: "Base Color", type: "color" },
      { name: "sideFill", label: "Side Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Edge Width", type: "number", min: 1, max: 5 },
      { name: "heightColor", label: "Height Line Color", type: "color" },
      { name: "radiusColor", label: "Radius Line Color", type: "color" },
      { name: "slantColor", label: "Slant Line Color", type: "color" }
    ],
    drag_points: ['apex', 'baseCenter'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "cuboid-diagonals-3d-001",
    category_id: "3d-geometry",
    name: "Cuboid with Diagonals",
    description: "3D rectangular prism with internal diagonal lines and labeled vertices A-H",
    coordinates: "8 vertices A-H, bottom face ABCD, top face EFGH with internal diagonals",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["cuboid", "3d", "diagonals", "vertices", "wireframe"],
    default_params: {
      width: 120,
      height: 80,
      depth: 100,
      centerX: 200,
      centerY: 150,
      showVertices: true,
      showEdges: true,
      showDiagonals: true,
      showLabels: true,
      edgeColor: "black",
      diagonalColor: "blue",
      vertexColor: "red",
      strokeWidth: 2,
      hiddenLineStyle: "dashed"
    },
    parameter_config: [
      { name: "width", label: "Width", type: "number", min: 80, max: 160 },
      { name: "height", label: "Height", type: "number", min: 60, max: 120 },
      { name: "depth", label: "Depth", type: "number", min: 60, max: 140 },
      { name: "centerX", label: "Center X", type: "number", min: 150, max: 250 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "showVertices", label: "Show Vertices", type: "checkbox" },
      { name: "showEdges", label: "Show Edges", type: "checkbox" },
      { name: "showDiagonals", label: "Show Diagonals", type: "checkbox" },
      { name: "showLabels", label: "Show Labels", type: "checkbox" },
      { name: "edgeColor", label: "Edge Color", type: "color" },
      { name: "diagonalColor", label: "Diagonal Color", type: "color" },
      { name: "vertexColor", label: "Vertex Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 },
      { name: "hiddenLineStyle", label: "Hidden Line Style", type: "select", options: ["dashed", "dotted", "thin"] }
    ],
    drag_points: ['center'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "intersecting-planes-triangle-3d-001",
    category_id: "3d-geometry",
    name: "Intersecting Planes with Triangle",
    description: "3D intersecting planes π₁ and π₂ with triangular connection and angle θ",
    coordinates: "Planes π₁ (parallelogram), π₂ (triangle), points B, Q, A, P, R with angle θ",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["planes", "intersection", "3d", "triangle", "angle", "geometry"],
    default_params: {
      plane1Width: 160,
      plane1Height: 100,
      plane2Width: 120,
      plane2Height: 80,
      centerX: 200,
      centerY: 150,
      angle: 45,
      showAngle: true,
      showRightAngle: true,
      showPoints: true,
      plane1Fill: "rgba(100,150,255,0.3)",
      plane2Fill: "rgba(255,150,100,0.3)",
      triangleFill: "rgba(150,255,150,0.4)",
      stroke: "black",
      strokeWidth: 2,
      angleColor: "red",
      rightAngleColor: "blue"
    },
    parameter_config: [
      { name: "plane1Width", label: "Plane π₁ Width", type: "number", min: 120, max: 200 },
      { name: "plane1Height", label: "Plane π₁ Height", type: "number", min: 80, max: 140 },
      { name: "plane2Width", label: "Plane π₂ Width", type: "number", min: 100, max: 160 },
      { name: "plane2Height", label: "Plane π₂ Height", type: "number", min: 60, max: 120 },
      { name: "centerX", label: "Center X", type: "number", min: 150, max: 250 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "angle", label: "Angle θ (degrees)", type: "number", min: 15, max: 75 },
      { name: "showAngle", label: "Show Angle θ", type: "checkbox" },
      { name: "showRightAngle", label: "Show Right Angle", type: "checkbox" },
      { name: "showPoints", label: "Show Point Labels", type: "checkbox" },
      { name: "plane1Fill", label: "Plane π₁ Color", type: "color" },
      { name: "plane2Fill", label: "Plane π₂ Color", type: "color" },
      { name: "triangleFill", label: "Triangle Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 },
      { name: "angleColor", label: "Angle Color", type: "color" },
      { name: "rightAngleColor", label: "Right Angle Color", type: "color" }
    ],
    drag_points: ['center', 'plane1', 'plane2'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "sphere-cross-section-3d-001",
    category_id: "3d-shapes",
    name: "Sphere Cross-Section",
    description: "2D representation of 3D sphere with circular cross-section disk and radius r",
    coordinates: "Sphere outline, cross-section disk at center with radius r",
    type: "2D",
    difficulty_level: "intermediate",
    tags: ["sphere", "cross-section", "disk", "radius", "3d-representation"],
    default_params: {
      centerX: 200,
      centerY: 150,
      sphereRadius: 100,
      diskRadius: 60,
      diskOffsetY: 0,
      showSphere: true,
      showDisk: true,
      showRadius: true,
      sphereColor: "rgba(139,69,19,0.8)",
      diskColor: "rgba(128,128,128,0.6)",
      radiusColor: "red",
      stroke: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 100, max: 300 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "sphereRadius", label: "Sphere Radius", type: "number", min: 60, max: 140 },
      { name: "diskRadius", label: "Disk Radius (r)", type: "number", min: 30, max: 100 },
      { name: "diskOffsetY", label: "Disk Y Offset", type: "number", min: -40, max: 40 },
      { name: "showSphere", label: "Show Sphere", type: "checkbox" },
      { name: "showDisk", label: "Show Cross-Section", type: "checkbox" },
      { name: "showRadius", label: "Show Radius Line", type: "checkbox" },
      { name: "sphereColor", label: "Sphere Color", type: "color" },
      { name: "diskColor", label: "Disk Color", type: "color" },
      { name: "radiusColor", label: "Radius Line Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    drag_points: ['center', 'disk'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "point-to-plane-geometry-3d-001",
    category_id: "3d-geometry",
    name: "Point to Plane Geometry",
    description: "3D point P above plane π with orthogonal projection N and right triangle PQN",
    coordinates: "Point P above plane π, projection N, point Q on plane, right angle at N, angle θ at Q",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["3d", "projection", "right-triangle", "plane", "angle", "orthogonal"],
    default_params: {
      centerX: 200,
      centerY: 150,
      planeWidth: 140,
      planeHeight: 100,
      pointPHeight: 80,
      pointQOffset: 40,
      showPlane: true,
      showProjection: true,
      showTriangle: true,
      showRightAngle: true,
      showAngle: true,
      planeFill: "rgba(200,200,200,0.4)",
      projectionColor: "red",
      triangleColor: "blue",
      rightAngleColor: "green",
      angleColor: "orange",
      stroke: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 150, max: 250 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "planeWidth", label: "Plane Width", type: "number", min: 100, max: 180 },
      { name: "planeHeight", label: "Plane Height", type: "number", min: 80, max: 140 },
      { name: "pointPHeight", label: "Point P Height", type: "number", min: 50, max: 120 },
      { name: "pointQOffset", label: "Point Q Offset", type: "number", min: 20, max: 60 },
      { name: "showPlane", label: "Show Plane π", type: "checkbox" },
      { name: "showProjection", label: "Show Projection Line", type: "checkbox" },
      { name: "showTriangle", label: "Show Triangle", type: "checkbox" },
      { name: "showRightAngle", label: "Show Right Angle", type: "checkbox" },
      { name: "showAngle", label: "Show Angle θ", type: "checkbox" },
      { name: "planeFill", label: "Plane Color", type: "color" },
      { name: "projectionColor", label: "Projection Color", type: "color" },
      { name: "triangleColor", label: "Triangle Color", type: "color" },
      { name: "rightAngleColor", label: "Right Angle Color", type: "color" },
      { name: "angleColor", label: "Angle θ Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    drag_points: ['pointP', 'pointQ', 'center'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  
  // NEW ADVANCED 3D GEOMETRY SKETCHES
  ...ADVANCED_3D_GEOMETRY_DATA
];

export const getSketchById = (id) => {
  return SKETCHES_DATA.find(sketch => sketch.id === id);
};

export const getSketchesByCategory = (categoryId) => {
  return SKETCHES_DATA.filter(sketch => sketch.category_id === categoryId);
};

export const getSketchesByType = (type) => {
  return SKETCHES_DATA.filter(sketch => sketch.type === type);
};

export const getSketchesByDifficulty = (difficulty) => {
  return SKETCHES_DATA.filter(sketch => sketch.difficulty_level === difficulty);
};

export const searchSketches = (query) => {
  const lowercaseQuery = query.toLowerCase();
  return SKETCHES_DATA.filter(sketch => 
    sketch.name.toLowerCase().includes(lowercaseQuery) ||
    sketch.description.toLowerCase().includes(lowercaseQuery) ||
    sketch.tags.some(tag => tag.toLowerCase().includes(lowercaseQuery))
  );
};
